import Select from 'react-select'
import {Form} from 'react-bootstrap';
import React from 'react';
import {useTranslation} from 'react-i18next';
import selectFilterStyles from '../../util/selectFilterStyles';
import getStyledSelectIndicatorsContainer from '../../util/getStyledSelectIndicatorsContainer';
import useCheckFilterFieldsValidity from '../../util/useCheckFilterFieldsValidity';
import Filter from './Filter';
import createUUID from '../../util/createUUID';
import checkOtherFiltersValid from '../../util/checkOtherFiltersValid';

const FilterMultiSelectDropdown = (props) => {
    const {t} = useTranslation();
    const checkFieldsValidity = useCheckFilterFieldsValidity();

    return <Filter
        key={`filter-${props.filter.name}`}
        filters={props.filters}
        setFilters={props.setFilters}
        loading={props.loading}
        filter={props.filter}
        filtersInitial={props.filtersInitial}
    >
        <Select
            id={`filter-${props.filter.name}`}
            isMulti={true}
            noOptionsMessage={() => t('Select.noOptionsMessage')}
            loadingMessage={() => t('Select.loadingMessage')}
            placeholder={t('Select.placeholder')}
            isDisabled={props.loading}
            isClearable={false}
            scrollIntoView={true}
            options={props.filter.config.options.map((option) => {
                return {
                    value: option,
                    label: props.APIOptions[option]
                }
            })}
            value={
                (() => {
                    const enabledValues = [];
                    for (const enabledValue of props.filter.value) {
                        for (const option of props.filter.config.options) {
                            if (enabledValue.value === option) {
                                enabledValues.push({value: option, label: props.APIOptions[option]});
                            }
                        }
                    }
                    return enabledValues;
                })()
            }
            components={
                {
                    IndicatorsContainer:
                        getStyledSelectIndicatorsContainer()
                }
            }
            onChange={
                (value) => {
                    const newValue = value ? value : [];
                    const filterValidity = checkFieldsValidity(newValue, props.filter.validation);

                    const othersValid = checkOtherFiltersValid(props.filter, props.filters);

                    props.setFilters({
                        ...props.filters,
                        changed: true,
                        valid: othersValid && filterValidity.valid,
                        filters: {
                            ...props.filters.filters,
                            [props.filter.name]: {
                                ...props.filter,
                                valid: filterValidity.valid,
                                touched: props.filtersInitial.filters[props.filter.name].value.length !== newValue.length ? true : false,
                                value: newValue,
                                errors: [...filterValidity.errors]
                            }
                        }
                    });
                }
            }
            onFocus={
                (event) => {
                    event.target.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"})
                }
            }
            styles={selectFilterStyles(props.filter)}
        />
        <div className="pt-1">
            <div className={!props.filter.valid ? "is-invalid" : null} />
            <Form.Control.Feedback
                type="invalid"
            >
                {
                    props.filter.errors.map(error => {
                        return <p key={createUUID()}>{error}</p>
                    })
                }
            </Form.Control.Feedback>
        </div>
    </Filter>
}

export default FilterMultiSelectDropdown;
